import React from 'react';

import LongTextResults from './LongTextResults';
import LikertResults from 'js/engines/SurveyAssessment/components/Review/QuestionResults/LikertResults';
import NullResults from 'js/engines/SurveyAssessment/components/Review/QuestionResults/NullResults';
import UnscoredLikertResults from 'js/engines/SurveyAssessment/components/Review/QuestionResults/UnscoredLikertResults';
import MultiSelectResults from 'js/engines/SurveyAssessment/components/Review/QuestionResults/MultiSelectResults';

const getComponent = (question) => {
  switch (question.type) {
    case 'likert':
      return LikertResults;

    case 'unscored-likert':
      return UnscoredLikertResults;

    case 'long-text':
      return LongTextResults;

    case 'multi-select':
    case 'single-select':
      return MultiSelectResults;

    default:
      return NullResults;
  }
};

const QuestionResults = (props) => {
  const ResultsComponent = getComponent(props.question);

  return <ResultsComponent {...props} />;
};

export default QuestionResults;
